import { useLocation } from "react-router-dom";
import { usePatchedNavigate } from "./usePatchedNavigate";

export function useNavigateWithQuery() {
  const navigate = usePatchedNavigate();
  const location = useLocation();

  const navigateWithUpdatedQuery = ({
    newPath,
    queryUpdates = {},
    event = null,
    delay = 100,
    target = "_self",
    noChangeCUrrentPath = false,
  }) => {
    const params = new URLSearchParams(location.search);
    const projectId = params.get('projectId');
    const isNewTab = target === "_blank" || (event && (event.ctrlKey || event.metaKey || event.button === 1));

    Object.entries(queryUpdates).forEach(([key, value]) => {
      params.set(key, value);
    });

    const updatedQueryString = params.toString();
    const currentPathWithQuery = `${location.pathname}?${updatedQueryString}`;
    !noChangeCUrrentPath && navigate(currentPathWithQuery, { replace: true });

    if (noChangeCUrrentPath) {
      newPath = newPath.includes("?") ? `${newPath}&${updatedQueryString}` : `${newPath}?${updatedQueryString}`;
    }

    setTimeout(() => {
      if (isNewTab) {
        newPath = newPath.includes("projectId") ? newPath : `${newPath}&projectId=${projectId}`;
        window.open(newPath, "_blank");
        return;
      }
      navigate(newPath);
    }, delay);
  };

  return navigateWithUpdatedQuery;
}
